



import { BaseEntityResponse } from '@m4u-angular/base/entities/BaseEntities';
import { BaseEntitiesResponse } from '@m4u-angular/base/entities/BaseEntities';
import { BaseDataResponse } from '@m4u-angular/base/entities/BaseEntities';
import { BaseResponse } from '@m4u-angular/base/entities/BaseEntities';
import { GenericListEntity } from '@m4u-angular/base/entities/BaseEntities';
import { DataGroupInfo } from '@m4u-angular/base/entities/BaseEntities';
import { BaseEndpoint } from '@m4u-angular/base/endpoint/BaseEndpoint';
import { BaseEndpointCRUD } from '@m4u-angular/base/endpoint/BaseEndpointCRUD';
import { DataLoadOptions } from '@m4u-angular/base/datalayer/DataLoadOptions';
import { APIGatewayService } from '@m4u-angular/core/gateway/APIGateway.service';
import { EnumRequestProgressTracking } from '@m4u-angular/core/framework/sysenums.enum';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { LoginRequest } from './../entities/loginrequest.entity';
import { BaseDocument } from './../entities/basedocument.entity';
import { InvoiceOneDocumentCodeParams } from './../params/invoiceonedocumentcode.param';
@Injectable()
export class LoginRequestEndpoint extends BaseEndpoint
{
    constructor(api: APIGatewayService) {super("LoginRequest", api);}
	

    public  CreateByInvoiceOneCode(Params: InvoiceOneDocumentCodeParams) : Observable<BaseEntityResponse<LoginRequest>>
	{
		return this.api.ExecutePostAction(this.ControllerName, 'CreateByInvoiceOneCode', Params,  undefined );
    }

    public  GetRelatedDocument(iLoginRequestID: number) : Observable<BaseEntityResponse<BaseDocument>>
	{
		return this.api.ExecuteGetAction(this.ControllerName, 'GetRelatedDocument',  {iLoginRequestID: iLoginRequestID} );
    }
}

